import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function Details() {
  const [IMDB, setIMDB] = useState({});
  const { id } = useParams();
  console.log(id);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(`https://www.omdbapi.com/?apikey=8aabe4c8&i=${id}`);
      const data = await response.json();
      setIMDB(data);
      console.log(data);
    };

    fetchData();
  }, [id]);

  return (
    <div className="movie-details">
      
      <div>
        <h3>Title</h3><span>{IMDB.Title}</span>
      </div>
      <div>
        <h3>Poster</h3><span>
          <img src={`${IMDB.Poster}`} alt="" />
        </span>
      </div>
      <div>
        <h3>Release Date</h3><span>{IMDB.Released}</span>
      </div>
      <div>
        <h3>IMDB Rating</h3><span>{IMDB.imdbRating}</span>
      </div>
      <div>
        <h3>Summary</h3><span>{IMDB.Plot}</span>
      </div>
    </div>
  )
}

export default Details;
